// @flow strict

import * as React from 'react';
import type { LoginFunction } from '@ta/login.types';

/**
 * A temporary solution to provide different versions of useAuthGated hooks in Lithium and non-Lithium environments.
 */
export type LoginContext = LoginFunction;

/** The Login context */
export const Login = React.createContext<LoginContext>(() => Promise.resolve(null));

/**
 * This hook is temporary implementation of common login hook. Once we prove auth-gate-lithium
 * works as expected in both Lithium and non-Lithium environment, we could replace this
 * implementation with it.
 * @returns {Function} login
 */
const useLogin = (): LoginFunction => React.useContext(Login);

export default useLogin;
